module.exports = __webpack_public_path__ + "static/media/shelton.274b66da.jpg";